import { ReactNode } from 'react';

interface QuestionCardProps {
  title: string;
  description?: string;
  children: ReactNode;
  error?: string;
}

export default function QuestionCard({ title, description, children, error }: QuestionCardProps) {
  return (
    <div className="bg-card border border-border rounded-lg p-6 lg:p-8 shadow-card">
      <h3 className="text-xl lg:text-2xl font-semibold text-text-primary mb-2">{title}</h3>
      {description && <p className="text-sm text-text-secondary mb-6">{description}</p>}
      <div className="space-y-4">{children}</div>
      {error && (
        <div className="mt-4 p-3 bg-error/10 border border-error/20 rounded-md">
          <p className="text-sm text-error">{error}</p>
        </div>
      )}
    </div>
  );
}